'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024100 from "./presto.types$$anon$100.js";
import * as $j_presto$002etypes$0024$0024anon$002496 from "./presto.types$$anon$96.js";
import * as $j_presto$002etypes$0024$0024anon$002498 from "./presto.types$$anon$98.js";
import * as $j_presto$002etypes$0024$002dTime$002dRange$0024 from "./presto.types$-Time-Range$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$95() {
  this.c46 = null;
  this.c3Y = null;
  this.c3Z = false;
  this.c47 = null;
  this.c48 = false;
  this.c4b = null;
  this.c44 = null;
  this.c45 = false;
  this.c40 = null;
  this.c41 = false;
  this.c42 = null;
  this.c43 = false;
  this.c49 = false;
  this.c4a = false;
  this.c46 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c4b = "TimeRange";
}
export { $c_Lpresto_types$$anon$95 as $c_Lpresto_types$$anon$95 };
$p = $c_Lpresto_types$$anon$95.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$95;
/** @constructor */
function $h_Lpresto_types$$anon$95() {
}
export { $h_Lpresto_types$$anon$95 as $h_Lpresto_types$$anon$95 };
$h_Lpresto_types$$anon$95.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.c46;
});
$p.M = (function() {
  if ((!this.c3Z)) {
    this.c3Y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c3Z = true;
  }
  return this.c3Y;
});
$p.O = (function() {
  if ((!this.c48)) {
    this.c47 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c48 = true;
  }
  return this.c47;
});
$p.D = (function() {
  return this.c4b;
});
$p.t = (function() {
  if ((!this.c45)) {
    this.c44 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("starts", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ends", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.c45 = true;
  }
  return this.c44;
});
$p.N = (function() {
  if ((!this.c41)) {
    this.c40 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$002496.$c_Lpresto_types$$anon$96(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$002498.$c_Lpresto_types$$anon$98(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.c41 = true;
  }
  return this.c40;
});
$p.Q = (function() {
  if ((!this.c43)) {
    this.c42 = new $j_presto$002etypes$0024$0024anon$0024100.$c_Lpresto_types$$anon$100();
    this.c43 = true;
  }
  return this.c42;
});
$p.v = (function() {
  if ((!this.c4a)) {
    this.c49 = false;
    this.c4a = true;
  }
  return this.c49;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee144) => ((p) => \u03b4scrutinee144.cHB(p)))($j_presto$002etypes$0024$002dTime$002dRange$0024.$m_Lpresto_types$TimeRange$())));
});
var $d_Lpresto_types$$anon$95 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$95, "presto.types$$anon$95", ({
  Yr: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$95 as $d_Lpresto_types$$anon$95 };
//# sourceMappingURL=presto.types$$anon$95.js.map
